import { render } from "./ViewerPanel.vue?vue&type=template&id=9fcc4834&scoped=true&ts=true"
import script from "./ViewerPanel.vue?vue&type=script&lang=ts"
export * from "./ViewerPanel.vue?vue&type=script&lang=ts"

import "./ViewerPanel.vue?vue&type=style&index=0&id=9fcc4834&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcc4834"]])

export default __exports__